import { render, staticRenderFns } from "./contactPhone.vue?vue&type=template&id=d7f7e36a&"
import script from "./contactPhone.vue?vue&type=script&lang=js&"
export * from "./contactPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports